import { useMutation } from "@tanstack/react-query";
import { signInHabilitarMe } from "../services/infractions.service";

export const useInfractionsSignInMutation = () =>
	useMutation({
		mutationKey: ["infractions:sign-in"],
		mutationFn: signInHabilitarMe,
	});
